<template>
  <div>
    <h3 class="text-center py-0">Proyectos Siglo XX</h3>
    <v-btn class="green darken-2 white--text ml-4 mb-0" v-if="!isdna" @click="editItem(null)">
      <v-icon small left class="mr-2"> mdi-plus </v-icon>
      Registrar nuevo proyecto
    </v-btn>
    <v-divider class="mt-2"></v-divider>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :loading="loading"
      :loader-height="4"
      :no-data-text="msg"
      disable-pagination
      hide-default-footer
      dense
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col>
              <v-select
                v-model="departamento"
                :items="departamentos"
                dense
                item-value="id"
                label="Filtrar por Departamento"
                prepend-inner-icon="mdi-map-search"
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="estado"
                :items="estados"
                dense
                item-value="id"
                label="Filtrar por Estado:"
                prepend-inner-icon="mdi-thermostat"
                clearable
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="versionpadre"
                :items="[
                  { id: false, text: `Crear version` },
                  { id: true, text: `Versiones creadas` },
                  { id: null, text: `Todos` },
                ]"
                dense
                item-value="id"
                label="Filtrar Version:"
                prepend-inner-icon="mdi-thermostat"
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                label="Filtrar por nombre"
                prepend-inner-icon="mdi-note-search"
                placeholder="_"
                outlined
                clearable
                dense
              ></v-text-field>
            </v-col>

            <v-col class="text-right">
              <v-btn class="gray darken-2 black--text" @click="initialize()">
                <v-icon small left class="mr-2"> mdi-clipboard-text-search-outline </v-icon>
                Aplicar filtro
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.estado`]="{ item }">
        <b :class="'ma-0 pa-0 ' + getestadopuntito(item.estado_programa)">
          {{ getestadoprograma(item.estado_programa) }}
        </b>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small color="blue" dark v-bind="attrs" v-on="on" text @click="viewproy(item)">
              <v-icon small class="mr-0 darken-4" color="blue">
                mdi-eye
              </v-icon>
            </v-btn>
          </template>
          <span>Ver proyecto</span>
        </v-tooltip>

        <v-tooltip top v-if="isdna && !item.version_padre">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              :disabled="item.version_padre > 0"
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              text
              @click="editItem(item)"
            >
              <v-icon small class="mr-0 darken-4" color="orange">
                mdi-book-edit
              </v-icon>
            </v-btn>
          </template>
          <span>Editar datos</span>
        </v-tooltip>

        <v-tooltip top v-if="isdna">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small color="orange" dark v-bind="attrs" v-on="on" text @click="deleteItem(item)">
              <v-icon small class="mr-0 darken-4" color="purple">
                mdi-check-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Cambiar estado</span>
        </v-tooltip>

        <v-tooltip top v-if="isdna && !item.version_padre">
          <template v-slot:activator="{ on, attrs }">
            <!-- estado_programa 1 = creado, debe estar aprobado en 2 -->
            <v-btn
              x-small
              :disabled="item.version_padre > 0 || item.estado_programa != 2"
              color="green"
              dark
              v-bind="attrs"
              v-on="on"
              text
              @click="newversion(item)"
            >
              <v-icon small class="mr-0 darken-4" color="green">
                mdi-atom-variant
              </v-icon>
            </v-btn>
          </template>
          <span>Actualizar version</span>
        </v-tooltip>

        <v-tooltip top v-if="isdna">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small color="primary" dark v-bind="attrs" v-on="on" text @click="agruparItem(item)">
              <v-icon small>
                mdi-bookmark-multiple
              </v-icon>
            </v-btn>
          </template>
          <span>Agrupar programas</span>
        </v-tooltip>

        <!-- <v-icon small class="mr-2 darken-4" color="orange" @click="editItem(item)">
          mdi-book-edit
        </v-icon>
        <v-icon small class="mr-2 darken-4" color="red" @click="deleteItem(item)">
          mdi-book-sync-outline
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-bookmark-multiple
        </v-icon> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pagestotal"></v-pagination>
      <!--  <v-text-field
        :value="itemsPerPage"
        label="Items per page"
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      ></v-text-field> -->
    </div>

    <div><XProgramanew ref="xprogramanew" v-on:xnewres="xnewres" /></div>
    <div><XProgramaver ref="xprogramaver" v-on:xnewres="xnewres" /></div>
    <div><XProgramaview ref="xprogramaview" v-on:xnewres="xnewres" /></div>
    <div><XProgramaestado ref="xprogramaestado" v-on:xnewestado="xnewres" /></div>
    <div><XProgramagrupos ref="xprogramagrupos" /></div>
    <div><programautils ref="xprogramautils" /></div>
    <notifications group="notificacionx" position="bottom right" />
  </div>
</template>

<style>
  .puntito1 {
    color: gray;
  }
  .puntito2 {
    content: '«';
    color: green;
  }
  .puntito3 {
    content: '«';
    color: red;
  }
</style>

<script>
  import programautils from '@/components/AXprogramautils';
  import XProgramanew from '@/components/AXprogramanuevo';
  import XProgramaver from '@/components/AXprogramaversion';
  import XProgramaview from '@/components/AXprogramaver';
  import XProgramaestado from '@/components/AXprogramaestado';
  import XProgramagrupos from '@/components/AXprogramagrupos';
  import xaxios from '@/xaxios';
  export default {
    data: (vue) => ({
      pagestotal: 0,
      page: 1,
      search: '',
      estado: null,
      versionpadre: null,
      dialog: false,
      loading: false,
      dialogDelete: false,
      departamentos: [],
      departamento: null,
      // estados: [
      //   { id: true, text: 'Activo' },
      //   { id: false, text: 'Inactivos' },
      // ],
      estados: [
        { id: 1, text: 'Creados' },
        { id: 2, text: 'Aprobados' },
        { id: 3, text: 'Rechazados' },
      ],
      headers: [
        { text: 'Nro.', sortable: false, value: 'index' },
        { text: 'Codigo', value: 'codigo' },
        { text: 'Programa', value: 'programa' },
        { text: 'Version', value: 'version' },
        { text: 'Area', value: 'area' },
        { text: 'Gestion', value: 'gestion' },
        { text: 'Estado', value: 'estado', width: 80 },
        { text: 'Opciones', value: 'actions', sortable: false, width: vue.isdirecion(), align: 'right' },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      isdna: false,
    }),
    components: { XProgramanew, XProgramaestado, XProgramaver, XProgramaview, programautils, XProgramagrupos },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'Nuevo Programa' : 'Editar Programa';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      estado() {
        this.initialize();
      },
      versionpadre() {
        this.initialize();
      },
      page() {
        this.initialize();
      },
      departamentos() {
        let existe = this.departamentos.find((x) => x.id == null);
        if (!existe) this.departamentos.push({ id: null, text: 'Todos' });
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize(cleardata = true) {
        this.loading = true;
        this.pagestotal = 0;
        if (cleardata) this.desserts = [];
        this.msg = '';
        const vue = this;
        const size = 20;
        let params = `asc=false&page=${this.page}&cantidad=${size}`;
        if (this.departamento) params += `&departamento_id=${this.departamento}`;
        if (this.estado) params += `&estado_programa=${this.estado}`;
        if (this.search) params += `&search=${this.search}`;
        if (this.versionpadre != null) params += `&version_padre=${this.versionpadre}`;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx?${params}`;
        //let url = `http://localhost:8090/api/v1/programa-unsxx?${params}`;
        xaxios
          .get(url)
          .then((res) => {
            let data = res.data.data;
            if (!data) data = [];
            vue.pagestotal = Math.floor(res.data.total / size) + 1;
            //window.console.log('programas:', res);
            data.map((x, i) => {
              x.index = i + 1;
            });
            vue.desserts = data;
            vue.loading = false;
            if (vue.desserts.length == 0) vue.msg = 'Sin resultados.';
          })
          .catch((error) => {
            window.console.error(error);
            if (error.response.data) vue.msg = error.response.data;
            //else vue.msg = error;
            vue.loading = false;
          });
      },
      editItem(item) {
        this.$refs.xprogramanew.openmodal(item);
      },
      newversion(item) {
        this.$refs.xprogramaver.openmodal(item);
      },
      viewproy(item) {
        this.$refs.xprogramaview.openmodal(item);
      },
      deleteItem(item) {
        this.$refs.xprogramaestado.openmodal(item);
      },
      agruparItem(item) {
        this.$refs.xprogramagrupos.openmodal(item);
      },
      getestadoprograma(estado) {
        if (estado == 1) return 'Creado';
        else if (estado == 2) return 'Aprobado';
        else if (estado == 3) return 'Rechazado';
      },
      getestadopuntito(estado) {
        if (estado == 1) return 'puntito1';
        else if (estado == 2) return 'puntito2';
        else if (estado == 3) return 'puntito3';
        return 'puntito1';
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      },
      xnewres(res) {
        //window.console.log('xnew: ', res);
        var noti = {
          group: 'notificacionx',
          type: 'success',
          title: 'Resultado',
          text: res,
          duration: 7000,
        };
        this.$notify(noti);
        this.initialize(false);
      },
      xnewestado(res) {
        window.console.log('xnewestado: ', res);
      },
      isdirecion() {
        this.isdna = this.$store.state.CARGO.id == 1;
        if (this.isdna) return 220;
        return 80;
      },
    },
    mounted() {
      this.$refs.xprogramautils.getDepartamentos(this);
      this.isdirecion();
    },
  };
</script>
